import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { RouterOutlet, Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { ApiErrorService } from '@core/services/api-error.service';
import { getApiBaseUrl } from '@core/services/api-base-url';
import { Header } from "@core/layout/header/header";
import { Footer } from "@core/layout/footer/footer";
import { SideDrawerMenu } from '@core/layout/menu/navigation/side-drawer-menu/side-drawer-menu';
import { ToastContainer } from '@core/layout/toast/toast-container';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ...SharedMaterialUIModule, Header, Footer, SideDrawerMenu, ToastContainer],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.css',
})
export class App {
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private readonly apiErrorService = inject(ApiErrorService);
  protected readonly hangfireDashboardUrl = `${getApiBaseUrl()}hangfire`;

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.apiErrorService.clearError());
  }
}
